import React, { Fragment, JSX } from "react";
import { IWorksheet } from "../../../model/interface/worksheet";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";

interface WorksheetTagProps {
  worksheetData: IWorksheet;
  handleSaveTags: (tags) => void;
  handleRemoveTag: (allTags, tags) => void;
  selectedTagIds: Array<number>;
}
function WorksheetTags(props: WorksheetTagProps): JSX.Element {
  return (
    <Fragment>
      <div className="text-gray-900 block px-4 py-4 text-sm shadow border-b border-gray-200 rounded-b-lg">
        <div>
          <div className="relative flex">
            <div className="w-full">
              <div className="col-span-6">
                <TagSelector
                  label={"Tags"}
                  onTagSelectChange={(tags) => {
                    props.handleSaveTags(tags);
                  }}
                  mode={TagSelectorMode.Edit}
                  removeTag={props.handleRemoveTag}
                  categoryId={0}
                  selectedTagIds={props.selectedTagIds}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default WorksheetTags;
